<template>
  <main class="ftn-container ftn-404">
    <h1 class="ftn-404__title">404</h1>
    <div class="ftn-404__description">Something's missing</div>
    <router-link
      :to="{ name: 'Homepage' }"
      class="ftn-btn">
      Discover
    </router-link>
  </main>
</template>

<script>
export default {
  name: 'NotFound',
  metaInfo: {
    title: 'Page not found',
  },
};
</script>
